import React, { useMemo } from "react";
import "./styles.css";
import Text from "../typography/text.js";
import { colors } from "../../theme/colors.js";

// export type StatusType = "failure" | "success" | "warning" | "complete";

// interface StatusIndicatorProps {
//   statusType: StatusType;
//   status: string;
// }

// Single source of truth for the indicator: the dot and the label always read
// from the same entry, so they can never drift apart.
const STATUS_COLORS = {
  failure: "failureColor",
  Rejected: "failureColor",
  PaymentFailed: "failureColor",
  success: "successColor",
  Approved: "successColor",
  warning: "warningColor",
  Pending: "warningColor",
  complete: "primaryColor",
  Completed: "primaryColor",
  Shipped: "primaryColor",
  "In Transit": "primaryColor",
  InTransit: "primaryColor",
  Delayed: "warningColor",
  Delivered: "successColor",
  primary: "primaryColor",
  collections: "primaryColor",
  pending: "primaryColor",
  submitted: "primaryColor",
  voided: "lightText",
};

const DEFAULT_COLOR = "lightText";

const StatusIndicatorHeader = (props) => {
  const { statusType, status } = props || {};

  const colorVar = useMemo(
    () => STATUS_COLORS[statusType] || DEFAULT_COLOR,
    [statusType]
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <div className="status" style={{ backgroundColor: colors[colorVar] }}></div>
      <Text variant="smallText" color={colorVar}>
        {status}
      </Text>
    </div>
  );
};

export default StatusIndicatorHeader;
